/**
 * Alpine x-data factory for community post compose (image previews).
 * Register on window / Alpine.data before Alpine.start().
 */
export function communityComposer({ maxImages = 4, maxImageKb = 5120 } = {}) {
    return {
        maxImages,
        maxImageKb,
        files: [],
        previews: [],
        error: '',
        previewId: 0,

        onFilesSelected(event) {
            const selected = Array.from(event.target.files || []);
            this.error = '';

            if (selected.length === 0) {
                return;
            }

            const next = [...this.files];
            for (const file of selected) {
                if (!file.type.startsWith('image/')) {
                    this.error = 'Only image files can be attached.';
                    continue;
                }
                if (file.size > this.maxImageKb * 1024) {
                    this.error = `Each image must be ${this.maxImageKb} KB or smaller.`;
                    continue;
                }
                if (next.length >= this.maxImages) {
                    this.error = `You can attach up to ${this.maxImages} images.`;
                    break;
                }
                next.push(file);
            }

            this.setFiles(next);
            // Allow re-selecting the same file after removal
            event.target.value = '';
        },

        removePreview(index) {
            const next = this.files.filter((_, i) => i !== index);
            this.setFiles(next);
            this.error = '';
        },

        setFiles(files) {
            this.previews.forEach((preview) => URL.revokeObjectURL(preview.url));
            this.files = files;
            this.previews = files.map((file) => ({
                id: ++this.previewId,
                name: file.name,
                url: URL.createObjectURL(file),
            }));
            this.syncInput();
        },

        syncInput() {
            const input = this.$refs.fileInput;
            if (!input || typeof DataTransfer === 'undefined') {
                return;
            }
            const transfer = new DataTransfer();
            this.files.forEach((file) => transfer.items.add(file));
            input.files = transfer.files;
        },

        destroy() {
            this.previews.forEach((preview) => URL.revokeObjectURL(preview.url));
        },
    };
}
